const translations = {
  es: {
    LOGIN_WITH_FACEBOOK_SING_UP: 'Regístrate con Facebook',
    LOGIN_WITH_GOOGLE_SING_UP: 'Regístrate con Google',
    LOGIN_WITH_FACEBOOK_SIGN_IN: 'Ingresar con Facebook',
    LOGIN_WITH_GOOGLE_SIGN_IN: 'Ingresar con Google',
    LOGIN_WITH_MICROSOFT_SIGN_IN: 'Ingresar con Microsoft',
    LOGIN_WITH_MICROSOFT_SECURE_AUTH: 'Ingresar con SecureAuth',
    LOGIN_WITH_OPENAGORA: 'Ingresar con Openagora',

    AUTH_VALIDATION_LEGALS_REQUIRED:
      'Debes aceptar los Términos, Condiciones y Políticas para continuar.',
    INPUT_REQUIRED: 'Campo requerido',
    VALIDATE_MAX_PASSWORD: 'Tu contraseña debe de tener máximo 6 caracteres',
    VALIDATE_MIN_PASSWORD: 'Tu contraseña debe de tener al menos 6 caracteres',
    VALIDATE_FORMAT_EMAIL: 'Por favor, ingresa un email válido.',
    PASSWORD_DOES_NOT_MATCH: 'La contraseña no coincide',

    LEGALS_TEXT_1: 'Acepto los ',
    LEGALS_TEXT_2: 'Términos, Condiciones y Políticas de Crehana.',

    CONTINUE_WITH: 'Continúa con:',

    SENDING: 'Enviando...',
    GENERIC_ERROR: 'Ocurrió un error. Inténtalo de nuevo.',
    // Generic fallback for a terminal Turnstile widget failure (blocked after
    // MAX_ERROR_RETRIES) — a different state than rate-limiting, kept as its own key
    // even though the copy currently matches GENERIC_ERROR.
    CAPTCHA_ERROR: 'Ocurrió un error. Inténtalo de nuevo.',
    // CORE-1795: shown when the Turnstile widget never got a site key at all
    // (`NEXT_PUBLIC_TURNSTILE_SITE_KEY` missing/empty at build time) — a
    // deploy/config problem, DISTINCT from CAPTCHA_ERROR (Cloudflare-side runtime
    // failure). Same "can't verify you're not a robot" user-facing framing so we
    // don't leak internal config details, but tracked as its own key/status
    // ('unconfigured') so this cause is never confused with the other two.
    CAPTCHA_UNCONFIGURED_ERROR:
      'No pudimos validar que no seas un robot. Vuelve a intentarlo.',
    // CORE-1795: no RATE_LIMITED_ERROR key here. `request_password_recovery` (the
    // mutation these 3 recovery forms call) NEVER returns error_code `rate_limited` —
    // it always responds `success=True` even when throttled, by BE design
    // (anti-enumeration + silent-throttling, Confluence 1987248131 §6.1). Only
    // `change_password_with_recovery` (B2BOrgResetPassword) can signal it — see that
    // page's own i18n locale files.

    B2C_EMAIL_MESSAGE: '* Si eres estudiante de empresas. [Clic aquí]({{url}})',
    B2B_EMAIL_ACTIVATE_MESSAGE:
      '* Aún no activaste tu cuenta. [Actívala aquí]({{url}})',
    B2B_EMAIL_REGISTERED_MESSAGE:
      '* Cuenta de empresas ya registrada. [Iniciar sesión]({{url}})',
    AUTH_VALIDATION_EMAIL_IN_USE: 'El email ingresado ya se encuentra en uso',

    OVERLAY_ERROR_TITLE: 'Oops, algo salió mal',
    OVERLAY_ERROR_BUTTON_TRY_AGAIN_LABEL: 'Intentar de nuevo',
  },
};

export default translations;
